import { useContext } from "react";
import { GlobalContext } from "../../../context/GlobalContext";
import { useGetTree } from "../../../hooks/useGetTree";
import useChangeTheme from "../../../shared/hooks/useChangeTheme";
import { changeFontSize } from "../../../utils/functions";
import TreeCategories from "../tree-categories/TreeCategories";
import "./MenuOffCanvas.scss";

// @ts-ignore
import moonWhite from "../../../assets/icons/CDA/moon_white.svg";
// @ts-ignore
import moonBlack from "../../../assets/icons/CDA/moon_black.svg";

const MenuOffCanvas = () => {
  const { fontSize } = useContext(GlobalContext);
  const [isDark, changeDarkMode] = useChangeTheme();
  const { link } = useGetTree();

  return (
    <div className="m-menu-offcanvas">
      <div className="accesibility-options">
        <span>Accesibilidad</span>
        <div className="accesibility-buttons">
          <button tabIndex={-1} onClick={changeDarkMode}>
            <img
              src={isDark ? moonBlack : moonWhite}
              alt="Botón para cambiar el tema de la página"
            />
          </button>

          <button
            onClick={() => changeFontSize("-", fontSize)}
            onKeyDown={e => e.code === "Enter" && changeFontSize("-", fontSize)}
            aria-label="Botón para disminuir letra"
          >
            <span>A-</span>
          </button>
          <button
            onClick={() => changeFontSize("+", fontSize)}
            onKeyDown={e => e.code === "Enter" && changeFontSize("+", fontSize)}
            aria-label="Botón para aumentar letra"
          >
            <span>A+</span>
          </button>
        </div>
      </div>
      <TreeCategories />
      <a href={link?.url} target="_blank">
        {link?.copy}
      </a>
    </div>
  );
};

export default MenuOffCanvas;
